import api from "./axios";

export const getLeadsApi = ({ status, type }) =>
  api.get("/leads", {
    params: {
      ...(type ? { type } : {}),
      ...(status && status !== "all" ? { status } : {}),
    },
  });

export const getLeadsDashboardStats = () => api.get("/leads/dashboardStats");

export const getSourcePerformanceApi = (params = {}) =>
  api.get("/leads/source-performance", { params });

export const getServicePerformanceApi = (params = {}) =>
  api.get("/leads/service-performance", { params });

export const getServiceDetailApi = (serviceId, params = {}) =>
  api.get(`/leads/service-performance/${serviceId}`, { params });

export const getServiceLeadsApi = (serviceId, params = {}) =>
  api.get(`/leads/service-performance/${serviceId}/leads`, { params });

export const getConversionDroppedAnalyticsApi = (params = {}) =>
  api.get("/leads/conversion-dropped-analytics", { params });

export const getRecentConversionsApi = (params = {}) =>
  api.get("/leads/recent-conversions", { params });

export const getRecentDroppedApi = (params = {}) =>
  api.get("/leads/recent-dropped", { params });

export const createLeadApi = (data) => api.post("/leads", data);

export const getLeadByIdApi = (id) => api.get(`/leads/${id}`);

export const updateLeadByIdApi = (id, data) => api.put(`/leads/${id}`, data);

export const updateGradeApi = (id, data) =>
  api.put(`/leads/${id}/status`, data);

export const addCallLogApi = (id, data) =>
  api.post(`/leads/${id}/call-logs`, data);

export const rescheduleLeadFollowupApi = (id, data) =>
  api.put(`/leads/${id}/followup/reschedule`, data);

export const markFollowupCompletedApi = (id, data) =>
  api.put(`/leads/${id}/followup/completed`, data);

// Bulk assign leads to agents
export const bulkAssignLeadsApi = (data) =>
  api.post("/leads/bulk-assign", data);

// Pipeline column settings
export const getPipelineColumnSettingsApi = () =>
  api.get("/leads/pipeline/column-settings");

export const savePipelineColumnSettingsApi = (data) =>
  api.post("/leads/pipeline/column-settings", data);
